import React, {useState} from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {elevation} from "@pg-design/elevation";
import {flexAbsoluteCenter, mr, pv, zIndex} from "@pg-design/helpers-css";
import {SearchIcon} from "@pg-design/icons-module";
import {Modal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";

import {OfferRankingForm} from "./offer_ranking_form/OfferRankingForm";

export function OfferRankingPanel() {
    const [isMobileFiltersActive, setMobileFiltersActive] = useState(false);

    return (
        <>
            <MobileFilterTrigger>
                <div css={triggerIconHolder} onClick={() => setMobileFiltersActive(true)}>
                    <SearchIcon size="2" css={mr(2)} />
                    <Text as="span" variant="info_txt_1">
                        Wybierz ranking
                    </Text>
                </div>
            </MobileFilterTrigger>
            <Modal isOpen={isMobileFiltersActive} onModalClose={() => setMobileFiltersActive(false)} fullScreen>
                <Modal.Header showCloseButton variant="bar_mini">
                    Wybierz ranking
                </Modal.Header>
                <Modal.Content>
                    <OfferRankingForm horizontal={false} />
                </Modal.Content>
            </Modal>
        </>
    );
}

const MobileFilterTrigger = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #fff;
    cursor: pointer;
    ${elevation(4)};
    ${zIndex(1)};

    @media (min-width: ${(props) => props.theme.breakpoints.md}) {
        display: none;
    }
`;

const triggerIconHolder = css`
    ${flexAbsoluteCenter};
    ${pv(3)};
`;
